import { createFileRoute, redirect } from "@tanstack/react-router";
import { memoryMemberListSearch } from "@/lib/memory-browse";

/** Legacy bookmark target — members live in the memory browser. */
export const Route = createFileRoute("/$owner/members/")({
	beforeLoad: ({ params }) => {
		throw redirect({ ...memoryMemberListSearch(params.owner), replace: true });
	},
	component: () => null,
});